import axios from "@/utils/request";
import axiosx from "@/utils/searchrequest";

// 栏目列表
export function columnList(data) {
  return axios({
    url: "/pz/eiiplat/pzColumnModule/selectHomePageList",
    method: "get",
    params: { moduleSort: 1, ...data }
  });
}
// 产品服务列表
export function listProduct(data) {
  return axios({
    url: "/pz/eiiplat/pzProductService/findProductsServiceList",
    method: "get",
    params: data
  });
}
// 平台介绍
export function platformDetail(data) {
  return axios({
    url: "/pz/eiiplat/pzPlatformModule/selectListPT",
    method: "get",
    params: { ...data, moduleSort: 1 }
  });
}
// 公司介绍
export function componyDetail(data) {
  return axios({
    url: "/pz/eiiplat/pzPlatformModule/selectListGS",
    method: "get",
    params: { ...data, moduleSort: 1 }
  });
}

// 产品服务全数据
export function listProductAll(data) {
  return axios({
    url: "/pz/eiiplat/pzProductService/findHomeCategoryList",
    method: "get",
    params: data
  });
}
// 解决方案全数据
export function listSolutionAll(data) {
  return axios({
    url: "/pz/eiiplat/pzSolutionService/findHomeCategoryList",
    method: "get",
    params: data
  });
}
// banner列表
export function listBanner(data) {
  return axios({
    url: "/pz/eiiplat/pzBannerService/selectList",
    method: "get",
    params: { useFlag: "1", ...data }
  });
}
// 生态伙伴数据
export function listPartner(data) {
  return axios({
    url: "/pz/eiiplat/pzPartnerMember/selectList",
    method: "get",
    params: data
  });
}

// 时间轴数据
export function listTime(data) {
  return axios({
    url: "/pz/eiiplat/pzPartnerTimeline/selectList",
    method: "get",
    params: data
  });
}

// 共建原则
export function listPrinciple(data) {
  return axios({
    url: "/pz/eiiplat/pzPartnerPrinciple/selectList",
    method: "get",
    params: data
  });
}
// 生态共建
export function detailCoBuilding(data) {
  return axios({
    url: "/pz/eiiplat/pzCooperateModule/selectDetailGJById",
    method: "get",
    params: { moduleSort: "1", ...data }
  });
}

// 生态共推
export function detailPromotion(data) {
  return axios({
    url: "/pz/eiiplat/pzCooperateModule/selectDetailGTById",
    method: "get",
    params: data
  });
}
// 解决方案列表
export function listSolution(data) {
  return axios({
    url: "/pz/eiiplat/pzSolutionService/findSolutionServiceList",
    method: "get",
    params: data
  });
}
// 案例数据
export function listCase(data) {
  return axios({
    url: "/pz/eiiplat/pzCaseModule/selectList",
    method: "get",
    params: data
  });
}
// 服务客户列表
export function listClient(data) {
  return axios({
    url: "/pz/eiiplat/pzHomepageCustomer/selectList",
    method: "get",
    params: data
  });
}
// 页脚信息
export function detailFooter(data) {
  return axios({
    url: "/pz/eiiplat/pzFooterService/selectDetailById",
    method: "get",
    params: data
  });
}
// 案例详情
export function detailCase(data) {
  return axios({
    url: "/pz/eiiplat/pzCaseModule/selectDetailById",
    method: "get",
    params: data
  });
}
// 产品服务详情
export function detailProduct(data) {
  return axios({
    url: "/pz/eiiplat/pzProductService/findDetailById",
    method: "get",
    params: { moduleSort: "1", ...data }
  });
}
// 产品服务详情
export function detailSolution(data) {
  return axios({
    url: "/pz/eiiplat/pzSolutionService/findDetailById",
    method: "get",
    params: data
  });
}
// 实施项目
export function listMap(data) {
  return axios({
    url: "/pz/eiiplat/pzImplementProject/selectList",
    method: "get",
    params: data
  });
}
// 提交访问途径
export function emitAccesspath(data) {
  return axios({
    url: "/pt/visitor-record/recordsDuration",
    method: "post",
    data: data
  });
}
//全局搜索 searchArticle
export function searchArticle(data) {
  return axiosx({
    url: "/article/page",
    method: "get",
    params: data
  });
}


// WEBPACK FOOTER //
// ./src/api/index.js